exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-input {\r\n    border: 1px solid;\r\n    padding: .2rem .75rem;\r\n}\r\n\r\n.right-border {\r\n    border-right: 1px solid;\r\n}\r\n\r\nfieldset.scheduler-border {\r\n    border: 1px solid !important;\r\n    padding: 0 1.4em 1.4em 1.4em !important;\r\n    margin: 0 0 1.5em 0 !important;\r\n    box-shadow:  0px 0px 0px 0px #000;\r\n}\r\n\r\nlegend.scheduler-border {\r\n    font-size: 1.2em !important;\r\n    text-align: left !important;\r\n    width:auto;\r\n    padding:0 10px;\r\n    border-bottom:none;\r\n}\r\n\r\n.bold {\r\n    font-weight: bold;\r\n}\r\n\r\n.nuevo-codigo {\r\n  margin-left: .3em;\r\n  cursor: pointer;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/subscription/nuevo.subscription.component.css
// module id = ../../../../../src/app/private/configuracion/subscription/nuevo.subscription.component.css
// module chunks = main